import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0B132B] text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4">
            <BrandLogo className="h-16" variant="light" />
          </div>
          <p className="mt-5 text-sm text-slate-400 max-w-md leading-relaxed">
            La mia stazione meteorologica personale in Via Loreto, a Palestrina. Un piccolo progetto autonomo che
            condivide pubblicamente e gratuitamente i dati raccolti dal sensore, 24 ore su 24.
          </p>
          <div className="mt-6 space-y-2 text-sm">
            <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#FBBF24]" /> Via Loreto, 00036 Palestrina (RM)</p>
            <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#FBBF24]" /> meteovialoreto@gmail.com</p>
          </div>
        </div>

        <div>
          <p className="text-white font-medium mb-4 text-sm uppercase tracking-widest">Link rapidi</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/dashboard" className="hover:text-white transition-colors">Dashboard</Link></li>
            <li><Link to="/grafici" className="hover:text-white transition-colors">Grafici</Link></li>
            <li><Link to="/storico" className="hover:text-white transition-colors">Storico</Link></li>
            <li><Link to="/previsioni" className="hover:text-white transition-colors">Previsioni</Link></li>
            <li><Link to="/stazione" className="hover:text-white transition-colors">La Stazione</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-white font-medium mb-4 text-sm uppercase tracking-widest">Informazioni</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contatti" className="hover:text-white transition-colors">Contatti</Link></li>
            <li><a href="#privacy" className="hover:text-white transition-colors">Privacy Policy</a></li>
            <li><a href="#cookie" className="hover:text-white transition-colors">Cookie Policy</a></li>
            <li><a href="#credits" className="hover:text-white transition-colors">Crediti</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Stazione Meteo Palestrina - Via Loreto. Progetto personale.</p>
          <p>Dati aggiornati ogni 60 secondi · Stazione predisposta per Davis Vantage Pro2 + WeeWX</p>
        </div>
      </div>
    </footer>
  );
}
